export default __webpack_public_path__ + "static/mens-915b967f03e344ee1eaa1acf08df7d41.webp";